<template>
    <v-footer class="black footerPos">
        <v-layout row wrap align-center>
            <v-flex xs12 class="text-xs-center">
                <div class="white--text">                 
                    <a class="white--text" href="https://electrowaves.fi">Electro Waves Oy</a>
                    <v-icon class="blue--text">copyright</v-icon>
                    2018
                </div>
            </v-flex>
        </v-layout>
    </v-footer>
</template>

<script>
export default {
  name: "CFooter",
  data() {
    return {};
  }
};
</script>

<style>
.footerPos {
  bottom: 0px;
  width: 100%;
  position: absolute;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue